import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const SectionTitle = (props: Props) => {
    return (
        <div className="py-2 font-bold text-[18px] text-primary-dark"  >
            {props.children}
        </div>
    )
}

export default SectionTitle